import styles from "./DeviceItem.module.css";

export default function DeviceItem({ device }) {
    const formatted = new Intl.DateTimeFormat("ru-RU").format(
        new Date(device.createdAt)
    );

    const pcPlatforms = ["windows", "linux", "macos"];
    const iconHref = pcPlatforms.includes(device.platform.toLowerCase())
        ? "#icon-computer"
        : "#icon-phone";

    return (
        <div className={styles.device}>
            <span className={styles.iconBadge} aria-hidden="true">
                <svg className={styles.icon}>
                    <use href={iconHref}></use>
                </svg>
            </span>

            <div className={styles.body}>
                <div className={styles.row}>
                    <p className={styles.model}>
                        {device.deviceModel.length > 20
                            ? `${device.deviceModel.slice(0, 20)}...`
                            : device.deviceModel}
                    </p>
                    <p className={`${styles.meta} ${styles.created}`}>{formatted}</p>
                </div>
                <p className={`${styles.meta} ${styles.system}`}>
                    {[device.platform, device.osVersion].filter(Boolean).join(" ")}
                </p>
            </div>
        </div>
    );
}
